import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  PLATFORM_ID,
  QueryList,
  Renderer2,
  ViewChildren,
} from '@angular/core';
import LocomotiveScroll from 'locomotive-scroll';

@Component({
  selector: 'app-affiliation-section',
  standalone: true,
  imports: [],
  templateUrl: './affiliation-section.component.html',
  styleUrl: './affiliation-section.component.scss',
})
export class AffiliationSectionComponent implements AfterViewInit, OnDestroy {
  isBrowser: boolean;
  private scroll: LocomotiveScroll | undefined;
  scrollProgress = 0;
  scrollThreshold = 100; // Scroll threshold before the bar starts updating
  @ViewChildren('resumeItems') resumeItems!: QueryList<ElementRef>;

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private renderer: Renderer2) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngAfterViewInit() {
    this.initializeScroll();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.9) {
            setTimeout(() => {
              this.renderer.addClass(entry.target, 'show');
              this.renderer.removeClass(entry.target, 'hide');
            }, 100);
          } else {
            this.renderer.addClass(entry.target, 'hide');
            this.renderer.removeClass(entry.target, 'show');
          }
        });
      },
      { threshold: 0.9 }
    );

    this.resumeItems.forEach((item) => {
      observer.observe(item.nativeElement);
    });
  }

  private initializeScroll() {
    if (this.isBrowser) {
      const element = document.querySelector('[data-scroll-container]') as HTMLElement;

      if (!element) {
        console.error('Scroll container not found!');
        return;
      }

      const direction = window.innerWidth <= 1024 ? 'vertical' : 'horizontal';

      this.scroll = new LocomotiveScroll({
        el: element,
        smooth: true,
        direction: direction,
      });

      this.scroll.update();

      this.scroll.on('scroll', (args: any) => {
        const scrollValue = direction === 'horizontal' ? args.scroll.x : args.scroll.y;
        const limitValue = direction === 'horizontal' ? args.limit.x : args.limit.y;

        if (scrollValue > this.scrollThreshold) {
          let rawProgress =
            ((scrollValue - this.scrollThreshold) / (limitValue - this.scrollThreshold)) * 100;
          rawProgress = Math.max(70, Math.min(rawProgress, 100));
          this.scrollProgress = ((rawProgress - 70) / (100 - 70)) * 100;
        } else {
          this.scrollProgress = 0;
        }
      });
    }
  }

  @HostListener('window:resize')
  onResize() {
    if (this.isBrowser && this.scroll) {
      this.scroll.destroy();
      this.initializeScroll();
    }
  }

  ngOnDestroy() {
    if (this.scroll) {
      this.scroll.destroy();
    }
  }
}
